import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiLogin, apiMe, apiLogout, getToken, setToken, clearToken } from "@/lib/userAuth";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      if (!getToken()) {
        if (active) setLoading(false);
        return;
      }
      try {
        const me = await apiMe();
        if (active) setUser(me);
      } catch {
        clearToken();
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  // Exchange a Firebase ID token for our own session + user record.
  const loginWithIdToken = useCallback(async (idToken) => {
    const { session_token, user: u } = await apiLogin(idToken);
    setToken(session_token);
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(async () => {
    try { await apiLogout(); } catch (e) { console.warn("logout error", e); }
    clearToken();
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, loginWithIdToken, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
